if (!customElements.get('blog-filter')) {
  class BlogFilter extends HTMLElement {
    constructor() {
      super();
      this.filterDropdown = document.getElementById('blog-filter-dropdown');
      this.bindEvents();
    }

    bindEvents() {
      this.filterDropdown.addEventListener('change', (evt) => {
        const link = this.querySelector(
          `#blog-filter-links a[data-tag="${evt.detail.selectedValue}"]`
        );
        if (link && link.href && link.href !== '#') window.location.href = link.href;
      });
    }
  }

  customElements.define('blog-filter', BlogFilter);
}

document.addEventListener('DOMContentLoaded', function() {
  const blogLinkList = document.querySelector('.blog-lg-linklist');
  const links = document.querySelectorAll('.blog-lg-link');
  const blogLgButton = document.getElementById('blogLgButton');
  let resizeTimeOut;

  let expanded = false;

  function updateVisibility() {
      const containerWidth = blogLinkList.clientWidth - 120;
      let totalWidth = 0;
      let visibleItemsCount = 0;
      console.log(containerWidth)
      links.forEach((item) => {
          totalWidth += item.offsetWidth + 10;
          if (totalWidth <= containerWidth) {
              item.style.display = 'inline-block';
              visibleItemsCount++;
          } else if (!expanded) {
              item.style.display = 'none';
          }
      });

      if (visibleItemsCount < links.length) {
          blogLgButton.style.display = 'block';
      } else {
          blogLgButton.style.display = 'none';
      }

      if (expanded) {
          blogLgButton.textContent = 'Ver menos';
      } else {
          blogLgButton.textContent = 'Ver más';
      }
  }

  blogLgButton.addEventListener('click', function() {
      expanded = !expanded;

      if (expanded) {
          for (let i = 0; i < links.length; i++) {
            links[i].style.display = 'inline-block';
          }
          blogLinkList.style.flexWrap = 'wrap';
      } else {
          blogLinkList.style.flexWrap = 'no-wrap';
          updateVisibility();
      }

      blogLgButton.textContent = expanded ? 'Ver menos' : 'Ver más';
  });

  window.addEventListener('resize', function() {
      clearTimeout(resizeTimeOut);
      resizeTimeOut = setTimeout(function() {
        expanded = false;
        updateVisibility();
      }, 100);
  });

  updateVisibility();
});
